export const InheritanceDeactivateModalContent = {
  header: 'Your information was submitted for review',
  content: `You can't edit what you've entered up to this point.
    <br />
    From here, you can either:
    <ul>
      <li><b>Continue</b> to open your account. You'll have a chance to review your personal info again before completing your application. Or,</li>
      <li><b>Start over</b> if you need to edit what you entered so far.</li>
    </ul>`,
  startOver: 'Start over',
  continue: 'Continue',
};
